import Alert from "./Alert";
import AuthenticationButton from "./AuthenticationButton";
import CheckboxEditor from "./CheckboxEditor";
import ChromeTabs from "./ChromeTabs";
import DatePicker from "./DatePicker";
import FormField from "./FormField";
import HoverMenu from "./HoverMenu";
import Loading from "./Loading";
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";
import Selector from "./Selector";
import MaskedNumber from "./MaskedNumber";
import MaskedText from "./MaskedText";
import MaskedTime from "./MaskedTime";
import QuickDates from "./QuickDates";
import ToggleEdit from "./ToggleEdit";
import UserRoles from "./UserRoles";
import ConvertedNumber from "./ConvertedNumber";
import CurrencyValue from "./CurrencyValue";
import Dialog from "./Dialog";
import FormDialog from "./FormDialog";
import Form from "./Form";
import SwitchValue from "./SwitchValue";
import FlightNumber from "./FlightNumber";
import LabelledPaper from "./LabelledPaper";
import FormCheckbox from "./FormCheckbox";
import FormSelect from "./FormSelect";
import FormMemo from "./FormMemo";
import RadioButtonGroup from "./RadioButtonGroup";
import ShcSelect from "./ShcSelect";
import ComboSelect from "./ComboSelect";
import ComboValues from "./ComboValues";
import AwbNumber from "./AwbNumber";
import Text from "./Text";
import ActionsList from "./ActionsList";
import DropzoneFileUpload from "./DropzoneFileUpload";
import DropzoneMultiFileUpload from "./DropzoneMultiFileUpload";
import FileViewer from "./FileViewer";
import AircraftSelect from "./AircraftSelect";
import AircraftMultiSelect from "./AircraftMultiSelect";
import AvatarEdit from "./AvatarEdit";
import UserRoleSelect from "./UserRoleSelect";
import NestedMenu from "./NestedMenu";
import HtmlTooltip from "./HtmlTooltip";
import LightTooltip from "./LightTooltip";
import TripLegSelect from "./TripLegMultiSelect";
import UldContourSelect from "./UldContourSelect";
import UldAllocationSelect from "./UldAllocationSelect";
import UldStackSelect from "./UldStackSelect";
import UldEquipmentSelect from "./UldEquipmentSelect";
import PalletAllocationSelect from "./PalletAllocationSelect";
import PalletTypeSelect from "./PalletTypeSelect";
import ComboMultiSelect from "./ComboMultiSelect";
import {companyUuidLookup} from "../modules/Companies/components/CompanyUuidLookup";
import ComboTemplate from "./ComboTemplate";
import UnNumberSelect from "./UnNumberSelect";
import IconButtonMenu from "./IconButtonMenu";
import ProgressBar from "./ProgressBar";
import Cropper from "./ImageCropper";

//Add components here that you want to be able toi use within the DataGrid
const DatagridControls = {
  CheckboxEditor,
  DatePicker,
  FormField,
  Selector,
  MaskedNumber,
  MaskedText,
  MaskedTime,
  ToggleEdit,
  ConvertedNumber,
  CurrencyValue,
  SwitchValue,
  ComboSelect,
  ComboValues,
  companyUuidLookup,
  ProgressBar,
}

export {
  DatagridControls,

  Alert,
  AuthenticationButton,
  CheckboxEditor,
  ChromeTabs,
  DatePicker,
  FormField,
  HoverMenu,
  Loading,
  LoginButton,
  LogoutButton,
  Selector,
  MaskedNumber,
  MaskedText,
  MaskedTime,
  QuickDates,
  ToggleEdit,
  UserRoles,
  ConvertedNumber,
  CurrencyValue,
  Dialog,
  FormDialog,
  SwitchValue,
  FlightNumber,
  Form,
  LabelledPaper,
  FormCheckbox,
  FormSelect,
  FormMemo,
  RadioButtonGroup,
  ShcSelect,
  ComboSelect,
  ComboValues,
  AwbNumber,
  Text,
  ActionsList,
  DropzoneFileUpload,
  DropzoneMultiFileUpload,
  FileViewer,
  AircraftSelect,
  AircraftMultiSelect,
  AvatarEdit,
  UserRoleSelect,
  NestedMenu,
  HtmlTooltip,
  LightTooltip,
  TripLegSelect,
  UldContourSelect,
  UldAllocationSelect,
  UldStackSelect,
  UldEquipmentSelect,
  ComboMultiSelect,
  ComboTemplate,
  UnNumberSelect,
  IconButtonMenu,
  ProgressBar,
  PalletTypeSelect,
  PalletAllocationSelect,
  Cropper
}
